import Modifier from 'ember-modifier'
import { service } from '@ember/service'
import { registerDestructor } from '@ember/destroyable'

export default class EnterDemoOnShiftClick extends Modifier<{ Element: HTMLElement }> {
  @service declare application: Application

  modify(element: HTMLElement) {
    element.addEventListener('click', this.onClick)
    registerDestructor(this, () => element.removeEventListener('click', this.onClick))
  }

  onClick = (event: MouseEvent) => {
    if (event.shiftKey) {
      this.application.enter()
    }
  }
}
